// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TermsAndConditions.css */
.terms-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  background-color: #ffffff;
  color: #333;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.terms-title {
  font-size: 2rem;
  font-weight: bold;
  color: #007bff;
  margin-bottom: 20px;
  text-align: center;
}

.terms-intro {
  font-size: 1rem;
  margin-bottom: 25px;
  text-align: justify;
}

.terms-section {
  margin-bottom: 25px;
}

.terms-section h2 {
  font-size: 1.2rem;
  color: #f3bd29;
  margin-bottom: 10px;
}

.terms-section p {
  font-size: 1rem;
  text-align: justify;
}

.terms-footer {
  margin-top: 30px;
  font-size: 0.95rem;
  color: #555;
  text-align: center;
}


@media (max-width: 768px) {
  .terms-container {
    margin: 20px 12px;
    padding: 15px;
    border-radius: 8px;
  }

  .terms-title {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  .terms-intro {
    font-size: 0.95rem;
    margin-bottom: 20px;
    text-align: left;
  }

  .terms-section {
    margin-bottom: 20px;
  }

  .terms-section h2 {
    font-size: 1.05rem;
    margin-bottom: 8px;
  }

  .terms-section p {
    font-size: 0.92rem;
    text-align: left;
    line-height: 1.5;
  }

  .terms-footer {
    font-size: 0.85rem;
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Terms-conditions/terms-conditions.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["/* TermsAndConditions.css */\n.terms-container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 20px;\n  background-color: #ffffff;\n  color: #333;\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.terms-title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #007bff;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.terms-intro {\n  font-size: 1rem;\n  margin-bottom: 25px;\n  text-align: justify;\n}\n\n.terms-section {\n  margin-bottom: 25px;\n}\n\n.terms-section h2 {\n  font-size: 1.2rem;\n  color: #f3bd29;\n  margin-bottom: 10px;\n}\n\n.terms-section p {\n  font-size: 1rem;\n  text-align: justify;\n}\n\n.terms-footer {\n  margin-top: 30px;\n  font-size: 0.95rem;\n  color: #555;\n  text-align: center;\n}\n\n\n@media (max-width: 768px) {\n  .terms-container {\n    margin: 20px 12px;\n    padding: 15px;\n    border-radius: 8px;\n  }\n\n  .terms-title {\n    font-size: 1.5rem;\n    margin-bottom: 15px;\n  }\n\n  .terms-intro {\n    font-size: 0.95rem;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n\n  .terms-section {\n    margin-bottom: 20px;\n  }\n\n  .terms-section h2 {\n    font-size: 1.05rem;\n    margin-bottom: 8px;\n  }\n\n  .terms-section p {\n    font-size: 0.92rem;\n    text-align: left;\n    line-height: 1.5;\n  }\n\n  .terms-footer {\n    font-size: 0.85rem;\n    margin-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
